import { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { projects } from '../data';
import { NeonText } from '../components/effects';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { RetroGrid } from '../components/effects';
import { useLanguage } from '../i18n';
import styles from './ProjectsPage.module.css';

export function ProjectsPage() {
  const { t } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  return (
    <>
      <RetroGrid />
      <Header />

      <main className={styles.main}>
        <div className={styles.container}>
          {/* Back Link */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.4 }}
          >
            <Link to="/" className={styles.backLink}>
              {t.projectsPage.backToHome}
            </Link>
          </motion.div>

          {/* Header */}
          <motion.header
            className={styles.header}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <NeonText as="h1" color="cyan" effect="glow" className={styles.title} animate={false}>
              {t.projectsPage.title}
            </NeonText>
            <p className={styles.subtitle}>
              {t.projectsPage.subtitle}
            </p>
          </motion.header>

          {/* Projects Grid */}
          <motion.div
            className={styles.projectsGrid}
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            {projects.map((project) => (
              <motion.article
                key={project.id}
                className={styles.projectCard}
                variants={itemVariants}
                whileHover={{ y: -5 }}
              >
                <Link to={`/proyecto/${project.id}`} className={styles.cardLink}>
                  <div className={styles.cardImageWrapper}>
                    <div className={styles.cardImage}>
                      {project.image && (
                        <img src={project.image} alt={project.title} />
                      )}
                    </div>
                    <div className={styles.cardOverlay}>
                      <span className={styles.viewProject}>{t.portfolio.viewDetails} →</span>
                    </div>
                  </div>

                  <div className={styles.cardContent}>
                    <div className={styles.cardMeta}>
                      <span className={styles.platform}>{project.platform}</span>
                      <span className={styles.date}>{project.date}</span>
                    </div>

                    <h3 className={styles.projectTitle}>{project.shortTitle}</h3>
                    <p className={styles.projectDescription}>{project.description}</p>

                    <div className={styles.techStack}>
                      {project.technology.slice(0, 3).map((tech) => (
                        <span key={tech} className={styles.techTag}>
                          {tech}
                        </span>
                      ))}
                    </div>
                  </div>
                </Link>
              </motion.article>
            ))}
          </motion.div>
        </div>
      </main>

      <Footer />
    </>
  );
}
